import React from 'react';
import { CheckCircle, Loader2, AlertTriangle, XCircle } from 'lucide-react';
import { Button } from '../../ui/button';

const gbp = (n) => `£${Number(n || 0).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

/** ETG certification: live hotel-rate confirmation (prebook) shown BEFORE payment, with price-change acceptance. */
export const HotelRateConfirm = ({ state, onAccept, onRetry, busy }) => {
  if (!state) return null;
  const hotels = Object.entries(state.hotels || {});
  return (
    <div className="rounded-xl border-2 border-slate-200 bg-white p-4 space-y-3" data-testid="pkg-prebook">
      <div className="flex items-center gap-2 font-bold text-slate-900">
        {state.loading ? <Loader2 className="h-4 w-4 animate-spin text-[#FF6600]" /> : state.status === 'OK' ? <CheckCircle className="h-4 w-4 text-emerald-600" /> : <XCircle className="h-4 w-4 text-rose-600" />}
        {state.loading ? 'Confirming live hotel rates with the supplier…' : state.status === 'OK' ? 'Hotel rates confirmed' : 'Hotel rate could not be confirmed'}
      </div>
      {hotels.map(([city, h]) => (
        <div key={city} className="text-sm flex flex-wrap items-center justify-between gap-2" data-testid={`pkg-prebook-${city}`}>
          <span className="text-slate-700">{city === 'makkah' ? 'Makkah' : 'Madinah'} · {h.hotel}</span>
          <span className={`font-semibold ${h.status === 'OK' ? 'text-emerald-700' : 'text-rose-700'}`}>
            {h.status === 'OK' ? (h.price_changed ? `Rate changed ${h.delta_gbp > 0 ? '+' : ''}${gbp(h.delta_gbp)}` : 'Available at quoted rate') : (h.rooms?.[0]?.message || 'Unavailable')}
          </span>
        </div>
      ))}
      {state.status === 'OK' && state.price_changed && !state.price_accepted && (
        <div className="rounded-lg bg-amber-50 border border-amber-300 p-3 space-y-2" data-testid="pkg-prebook-price-changed">
          <div className="flex items-start gap-2 text-sm text-amber-900"><AlertTriangle className="h-4 w-4 mt-0.5 flex-shrink-0" />
            <span>The supplier's hotel rate has changed since your quote. New package total <strong>{gbp(state.new_total)}</strong> (was {gbp(state.quoted_total)}). Please accept the new price to continue.</span></div>
          <Button size="sm" onClick={onAccept} disabled={busy} className="bg-[#FF6600] hover:bg-[#e65c00] text-white" data-testid="pkg-prebook-accept-price">Accept new price {gbp(state.new_total)}</Button>
        </div>
      )}
      {state.status === 'OK' && state.price_accepted && <div className="text-xs text-emerald-700 font-semibold" data-testid="pkg-prebook-price-accepted">New price accepted — {gbp(state.new_total)}</div>}
      {state.status === 'FAILED' && !state.loading && (
        <div className="flex flex-wrap items-center gap-2 text-sm text-rose-800" data-testid="pkg-prebook-failed">
          <span>We couldn't confirm this room with the supplier. Try again, pick another hotel, or call Flight 380 on 01908 220000.</span>
          <Button size="sm" variant="outline" onClick={onRetry} disabled={busy} data-testid="pkg-prebook-retry">Try again</Button>
        </div>
      )}
    </div>
  );
};
